import { useParams } from 'next/navigation';

import { useRealtorInfo } from '@/app/(realtor)/realtor/[realtorCd]/api';
import useMobileStore from '@/store/mobileStore';
import { handleSendGAEvent } from '@/utils/google';
import { sendTextMessage } from '@/utils/js/sms';

export default function RealtorDetailBottom() {
  const { isMobile, currentDevice, isWebView } = useMobileStore();
  const { realtorCd } = useParams();
  const { data } = useRealtorInfo(realtorCd as string);

  if (!isMobile) return null;

  return (
    <div className="bottom_btn ratio fixed_bottom">
      <button
        className="btn_line_primary"
        onClick={() => {
          if (isWebView) {
            handleSendGAEvent('realtor_detail_call_btn', {
              event_category: 'realtor',
              realtor_id: realtorCd,
            });
          } else {
            handleSendGAEvent('share_realtor_call_btn', {
              event_category: 'share',
              realtor_id: realtorCd,
            });
          }
          location.href = `tel:${data?.rphone}`;
        }}
      >
        <i className="icon_call_line_purple"></i>전화
      </button>
      <button
        className="btn_primary"
        onClick={() => {
          if (isWebView) {
            handleSendGAEvent('realtor_detail_sms_btn', {
              event_category: 'realtor',
              realtor_id: realtorCd,
            });
          } else {
            handleSendGAEvent('share_realtor_sms_btn', {
              event_category: 'share',
              realtor_id: realtorCd,
            });
          }
          if (data?.cphone) {
            location.href = sendTextMessage(
              data?.cphone,
              '이실장을 통해 매물 상담문의 드립니다. 확인 후 연락바랍니다.​\n감사합니다',
              currentDevice!,
            );
          }
        }}
      >
        <i className="icon_message_line_white"></i>문자
      </button>
    </div>
  );
}
